import { render, staticRenderFns } from "./Linkage.vue?vue&type=template&id=393053c6&scoped=true"
import script from "./Linkage.vue?vue&type=script&lang=js"
export * from "./Linkage.vue?vue&type=script&lang=js"
import style0 from "./Linkage.vue?vue&type=style&index=0&id=393053c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "393053c6",
  null
  
)

export default component.exports